import type { DataType, HttpClient, HttpClientOptions } from '../types/api';

export const createHttpClient = (http: <T>(path: string, options?: HttpClientOptions) => Promise<T>): HttpClient => ({
  get: <T>(path: string, options?: { query?: DataType }) => http<T>(path, options),
  post: <T>(path: string, options?: HttpClientOptions) => http<T>(path, { ...options, method: 'POST' }),
  put: <T>(path: string, options?: HttpClientOptions) => http<T>(path, { ...options, method: 'PUT' }),
  delete: <T>(path: string, options?: HttpClientOptions) => http<T>(path, { ...options, method: 'DELETE' }),
});
